var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgIconKey48Filled = function SvgIconKey48Filled(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "current",
    height: "current",
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M28.83 9.9a9 9 0 0 0-7.48 14.13L10.63 34.71l2.4 2.41 2-2 2.72 2.72 2.41-2.41-2.72-2.71 1.52-1.52 2.71 2.72 2.41-2.41-2.72-2.71 2.32-2.33a9 9 0 1 0 5.08-16.53l.07-.04Z",
    fill: "current"
  })));
};
export default SvgIconKey48Filled;